// extracted by mini-css-extract-plugin
export default {"container":"Snflsk","visible":"uG0u6r","hidden":"yqC9OE","close-button":"crx5If","closeButton":"crx5If"};